import { createSlice } from '@reduxjs/toolkit';
import { IPage } from '../../types/page';

const initialState: IPage = {
  stickyScrollBtnVisible: false,
  mobileFiltersVisible: false,
  modals: {
    newDreamOnboardingModalOpen: false,
    homeProfileOnboardingModalOpen: false,
  },
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    toggleStickyScrollBtn(state, action) {
      state.stickyScrollBtnVisible = action.payload;
    },
    toggleMobileFiltersModal(state, action) {
      state.mobileFiltersVisible = action.payload;
    },
    openNewDreamOnboardingModal(state, action) {
      state.modals.newDreamOnboardingModalOpen = action.payload;
    },
    openHomeProfileOnboardingModal(state, action) {
      state.modals.homeProfileOnboardingModalOpen = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  reducer: pageReducer,
  actions: {
    toggleStickyScrollBtn,
    toggleMobileFiltersModal,
    openNewDreamOnboardingModal,
    openHomeProfileOnboardingModal,
  },
} = pageSlice;
